module.exports = __webpack_public_path__ + "fonts/ChivasLux_SBd.da2b4e41.ttf";